/**
 * Collection of design tokens for text line heights. These values determine the vertical space
 * between lines of text for readability and aesthetics.
 */ const lineHeights = {
    tight: 1.2,
    regular: 1.5,
    loose: 1.8
};

export { lineHeights };
//# sourceMappingURL=line-heights.js.map
